import React from "react"
import { Button } from "../../../designSystem/button/Button";
import { AnimatedCollapsibleContent } from "../../../designSystem/collapsible/AnimatedCollapsibleContent";
import { CollapsiblePanel } from "../../../designSystem/collapsible/CollapsiblePanel";
import { Flex, FlexItem } from "../../../designSystem/compositeComponents/FlexHelpers";
import { Icon } from "../../../designSystem/icons/Icons";
import { P } from "../../../designSystem/typography/Body";
import { H1, H2, H3 } from "../../../designSystem/typography/Heading";
import { Card } from "../../../designSystem/Card";
import { ShowMorePanel } from "../../../designSystem/compositeComponents/ShowMorePanel";

export const ContainerOverview = (): JSX.Element => 
{

    const [openContent, setOpenContent] = React.useState(false);

    function activeCollapsibleContent() {
        setOpenContent(!openContent);
    }

    return (
        <Flex flexDirection="column" gap={24}>
            <H1>Containers</H1>

            <Flex flexDirection="column" gap={8}>
                <H2>ShowMorePanel</H2>
                <Flex flexDirection='row'>
                    <FlexItem flexGrow="1">
                        <Card variant="outlined">
                            <ShowMorePanel>
                                
                                {[...Array(32)].map((_, i) => (
                                    <Card variant="outlined" key={i}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</Card>
                                ))}

                            </ShowMorePanel>
                        </Card>
                    </FlexItem>
                </Flex>
            </Flex>
        
            <Flex flexDirection="column" gap={8}>
                <H2>CollapsiblePanel</H2>
                <Flex flexDirection='row' justifyContent="stretch" gap={16}>
                    <FlexItem flexGrow="1">
                        <CollapsiblePanel
                            openHeader={<HeaderOpen />}
                            closedOrDefaultHeader={<HeaderClosed />}>
                            
                            <P>Hammock mixtape lorem quis af disrupt occupy. Fugiat post-ironic deserunt truffaut, sint Brooklyn esse intelligentsia viral duis neutral milk hotel irure art party bodega boys elit. Stumptown proident gentrify craft beer 3 wolf moon, tumblr edison bulb echo park tattooed fanny pack paleo. Nisi aliquip palo santo, subway tile seitan pok pok squid. Blog literally nostrud exercitation occupy wolf meditation waistcoat cillum. Aliquip normcore blackbird spyplane gochujang PBR&B taxidermy coloring book solarpunk chicharrones nulla etsy.</P>

                        </CollapsiblePanel>
                    </FlexItem>
                </Flex>
            </Flex>

            <Flex flexDirection="column" gap={8}>
                <Button onClick={ () => activeCollapsibleContent()} text="Se indhold" variant="filled" />
                <AnimatedCollapsibleContent open={openContent}>
                    <P>Im baby bicycle rights tousled distillery hot chicken subway tile. Put a bird on it artisan etsy la croix, brunch organic chambray locavore raclette synth. Art party church-key XOXO gochujang marfa humblebrag poutine pabst mlkshk cray letterpress. Mixtape hell of banh mi trust fund echo park taxidermy, letterpress synth wayfarers cred ascot stumptown bespoke. Street art pabst unicorn blog viral flannel, asymmetrical art party solarpunk master cleanse big mood yuccie. Artisan green juice hexagon truffaut chartreuse migas cold-pressed put a bird on it. Tattooed skateboard kinfolk, drinking vinegar adaptogen paleo lumbersexual jawn chambray.</P>
                </AnimatedCollapsibleContent>
            </Flex>
 
        </Flex>
    );
}

const HeaderOpen = (): JSX.Element => {
    return (
        <Flex flexDirection="row" alignItems="center"><Icon name='facility_serverRoom' /><Button icon='cloud_upload' onClick={() => alert("Der er klikket")} variant={"text"}/> <H3>CollapsiblePanel open</H3></Flex>
    )
;}

const HeaderClosed = (): JSX.Element => {
    return (
        <Flex flexDirection="row" alignItems="center"><Icon name='facility_serverRoom' /><Button icon='cloud_upload' onClick={() => alert("Der er klikket")} variant={"text"}/><H3>CollapsiblePanel closed</H3></Flex>
    )
;}
